import api from "./api";

interface VideoRetryFailedVideoParams {
  tasks: {
    failed_video_id: string;
  }[];
}

interface VideoRetryFailedVideoProps {
  failedVideoId: string;
}

const URL = "/video/retry-failed-video";

export const videoRetryFailedVideo = async (
  props: VideoRetryFailedVideoProps
) => {
  const params: VideoRetryFailedVideoParams = {
    tasks: [{
      failed_video_id: props.failedVideoId,
    }]
  };
  const res = await api.post<unknown>(URL, params, {
    // 5分钟 避免触发超时
    timeout: 1000 * 60 * 5,
  });
  return res;
};
